import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import GTMBodyScript from './components/GTMBodyScript';
import GTMHeadScript from './components/GTMHeadScript';
import ClarityScript from './components/ClarityScript';
export function App() {
  return <HelmetProvider data-id="element-0">
      <GTMHeadScript data-id="element-1" />
      <GTMBodyScript data-id="element-2" />
      <ClarityScript data-id="element-3" />
      <BrowserRouter data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}